import ng = require('angular');
import { ArchiSmallServices } from '../../services/archismall.service';
import { AlertService } from '../../services/ui/alert.service';
import { FormService } from '../../services/ui/form.service';

export const LoginComponent: ng.IComponentOptions = {
    template: require('./login.html'),
    controller: class LoginController implements ng.IController {

        static $inject: string[] = [
            '$state',
            'ArchiSmallServices',
            'AlertService',
            'FormService',
            'store',
            '$uibModal'
        ];

        private credentials: any;

        private invalidLogin: boolean;

        constructor(
            private $state: ng.ui.IStateService,
            private archiSmallServices: ArchiSmallServices,
            private alertService: AlertService,
            private formService: FormService,
            private store: ng.a0.storage.IStoreService,
            private $uibModal: ng.ui.bootstrap.IModalService
        ) {
            this.credentials = {
                'username': '',
                'password': ''
            };

            this.invalidLogin = false;
        }

        userlogin = () => {
            this.archiSmallServices.userLogin(this.credentials)
                .then((response) => {
                    this.loginSuccessCallback(response);
                }, (error) => {
                    if (error) {
                        if (error.errorCode && error.errorCode === 9) {
                            let modalInstance = this.$uibModal.open({
                                component: 'activationErrorModalComponent',
                                windowClass: 'center-modal',
                                resolve: {
                                    config: () => {
                                        return {
                                            buttons: [
                                                {
                                                    'id': 1,
                                                    'icon': 'fa fa-check-circle-o',
                                                    'label': 'Ok'
                                                },
                                                {
                                                    'id': 2,
                                                    'icon': 'fa fa-paper-plane',
                                                    'label': 'Reinvia mail di Attivazione'
                                                },
                                            ]
                                        };
                                    }
                                }
                            });

                            modalInstance.result.then((pressedButtonId) => {
                                if (pressedButtonId !== undefined && pressedButtonId === 2) {
                                    this.archiSmallServices.resendActivationMail(this.credentials.username)
                                        .then((response) => {
                                            this.$uibModal.open({
                                                component: 'activationMailSentModalComponent',
                                                windowClass: 'center-modal'
                                            }).result.then((response) => {
                                                // ?
                                            }, (error) => {
                                                // ?
                                            });
                                        }, (error) => {
                                            this.alertService.alert('error', error);
                                        });
                                }
                            }, () => {
                                // emptyblock
                            });
                        } else {
                            this.alertService.alert('error', error);
                        }
                    } else {
                        this.alertService.alert('error', 'Server Error');
                    }
                });
        }

        openRecoverPasswordModal(size: string) {
            this.$uibModal.open({
                animation: true,
                component: 'recoverPasswordModalComponent',
                size: size,
                windowClass: 'center-modal',
            }).result.then((response) => {
                // ?
            }, (error) => {
                // ?
            });
        }

        private loginSuccessCallback = (response: any) => {
            if (response.Result === 1) {
                this.invalidLogin = false;
                this.store.set('user', response);
                this.store.set('jwt', response.token);
                if (response.subscription.subscriptionCancelled) {
                    this.$state.go('unsubscription.unsubscription-index');
                } else {
                    this.$state.go('home.home-index');
                }
            } else {
                this.invalidLogin = true;
            }
        }
    }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/login/login.component.ts